import {useState, useEffect} from 'react';

const format = (time) => {
    const days = Math.floor(time / (24 * 60 * 60 * 1e3));
    time -= days * (24 * 60 * 60 * 1e3);

    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / 60e3);
    time -= minutes * 60e3;

    const seconds = Math.floor(time / 1e3);

    if(days > 0)
        return [[days, 'dd'], [hours, 'hh'], [minutes, 'mm']];

    return [[hours, 'hh'], [minutes, 'mm'], [seconds, 'ss']];
}

export default ({timestamp}) => {
    const [time, setTime] = useState(timestamp - Date.now());

    useEffect(() => {
        if(time > 0)
            window.depositBonusBlockWidgetTimeout = setTimeout(() => {
                setTime(timestamp - Date.now());
            }, 500);

        return () => window.clearTimeout(window.depositBonusBlockWidgetTimeout);
    }, [time]);

    const formatted_time = format(time);

    return (
        <div className="timer">
            {formatted_time.map((block, key) => {
                return (
                    <div className="block" key={key}>
                        <div className="squad">{block[0] < 10 ? `0${block[0]}` : block[0]}</div>
                        <span>{block[1]}</span>
                    </div>
                )
            })}
        </div>
    )
}